import { Component } from '@angular/core';
import { DatePipe } from "@angular/common";
import { RouterOutlet } from '@angular/router';
import { NgFor } from "@angular/common";
import { NgClass } from "@angular/common";
import { Observable, of } from 'rxjs';

import { OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';



import { PlayListBanner } from '../../objects/playlistbanner';


import { MatTableModule } from '@angular/material/table';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { MatIconModule } from '@angular/material/icon';
import { DataSource } from '@angular/cdk/collections';
import { PlayListBannerDataService } from '../../services/playlistbanner-data-service';
import { HttpClientModule } from '@angular/common/http';

import { NgIf } from "@angular/common";


import { MatListModule } from '@angular/material/list';

import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
} from '@angular/material/dialog';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';




/**
 * @title Basic use of the tab group
 */
@Component({
  selector: 'playlistbanner-component',
  templateUrl: './playlistbanner-component.html',
  styleUrls: ['./playlistbanner-component.css'],
  standalone: true,
  imports: [NgFor, NgIf, NgClass,  MatButtonModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, FormsModule, MatTableModule, DatePipe, MatDatepickerModule, HttpClientModule],
})
export class PlayListBannerComponent implements OnDestroy {



  private alive = true; // Flag to control the interval subscription
  private refreshInterval: number = 1000; // Refresh interval in milliseconds (1 minute)
  private dataRefreshSubscription: Subscription;



  playlistbanner: PlayListBanner;

  constructor(private playlistBannerDataService: PlayListBannerDataService) { }

  ngOnInit() {
    // Start the interval and subscribe to it

    this.refreshData();


    this.dataRefreshSubscription = interval(this.refreshInterval)
      .pipe(
        takeWhile(() => this.alive) // Ensure the interval continues while the component is alive
      )
      .subscribe(() => {
        this.refreshData();
      });
  }

  ngOnDestroy() {
    // Unsubscribe from the interval to prevent memory leaks
    this.alive = false;
    if (this.dataRefreshSubscription) {
      this.dataRefreshSubscription.unsubscribe();
    }
  }

  private refreshData() {
    // Fetch data from the service
    this.playlistBannerDataService.getPlayListBanner().subscribe(
      (data) => {
        // Handle the fetched data as needed
        console.log('Data refreshed:', data);
        this.playlistbanner = data;
      },
      (error) => {
        console.error('Error refreshing data:', error);
      }
    );
  }


}